import { render, staticRenderFns } from "./MinsideDocumentPage.vue?vue&type=template&id=196f28cf&"
import script from "./MinsideDocumentPage.vue?vue&type=script&lang=ts&"
export * from "./MinsideDocumentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports